<style lang='scss'>
</style>

<script>
import Layout from '@layouts/main'

import {AxiosHelper} from '@src/utils/utils';

export default {
	components: { Layout, },
  data() {
    return {
			guests : []
		}
	},
	beforeCreate() {
		AxiosHelper.get(`/api/nas/vmm`).then(ret => {
			this.guests = ret.data.guests
		});
	},
	created() {
	},
	mounted() {
	},
	methods : {
		statusChange(idx, status) {
			return this.guests.map((item, i) => {
				if(idx === i) {
					return {...item, status : status};
				}
				return item;
			});
		},

		checkStatus(idx) {
			AxiosHelper.get(`/api/nas/vmm/${this.guests[idx].guest_name}`).then(ret => {
				if(this.guests[idx].status === 'shutting') {
					if(ret.data.status === 'shutdown') {
						this.guests = this.statusChange(idx, ret.data.status)
					}
				}
				else {
					this.guests = this.statusChange(idx, ret.data.status)
				}
			});
		},

		shutdown(idx) {
			if(!window.confirm('전원을 끌까요?'))
				return;

			this.guests = this.statusChange(idx, 'shutting')
			const timer = setInterval(() => {
				this.checkStatus(idx);
				if(this.guests[idx].status === 'shutdown') {
					clearInterval(timer);
				}
			}, 3000);
	
			AxiosHelper.get(`/api/nas/vmm/${this.guests[idx].guest_name}/shutdown`).then(ret => {
			});
		
		},

		poweron(idx) {
			if(!window.confirm('전원을 킬까요?'))
				return;

			const timer = setInterval(() => {
				this.checkStatus(idx);
				if(this.guests[idx].status === 'running') {
					clearInterval(timer);
				}
			}, 3000);

			AxiosHelper.get(`/api/nas/vmm/${this.guests[idx].guest_name}/poweron`).then(ret => {
			});
		},


	}
}
</script>

<template>
  <Layout>
    <C.PageHeader title="VMM 상태" />

		<C.Row>
			<C.Col v-for="(machine, idx) in guests" :key="machine.guest_name" lg="2" sm="6" xs="6">
				<div class="card-box ribbon-box">
					<div v-show="machine.status === 'running'" class="ribbon ribbon-success float-right">실행중</div>
					<div v-show="machine.status === 'preparing' || machine.status === 'booting'" class="ribbon ribbon-info float-right">시작중</div>
					<div v-show="machine.status === 'shutting'" class="ribbon ribbon-warning float-right">종료중</div>
					<div v-show="machine.status === 'shutdown'" class="ribbon ribbon-secondary float-right">종료</div>

					<h5 class="text-blue float-left mt-0">{{machine.guest_name}}</h5>
					<div class="ribbon-content">
						<div v-show="machine.status === 'running'" style="cursor: pointer" class="avatar-lg rounded-circle bg-soft-danger border-danger border"
							@click="shutdown(idx)">
							<i class="fe-power font-22 avatar-title text-danger"></i>
						</div>
						<div v-show="machine.status === 'shutdown'" style="cursor: pointer" class="avatar-lg rounded-circle bg-soft-success border-success border"
							@click="poweron(idx)">
							<i class="fe-play font-22 avatar-title text-success"></i>
						</div>

					</div>
				</div>
			</C.Col>

		</C.Row>
  </Layout>
</template>